import { useState, useCallback } from 'react';
import { pagoPorEstudioAPI } from '../../../core/api/api';

const ROLES = [
  { id: '2', rol: 'Técnico' },
  { id: '4', rol: 'Médico' },
];

export const usePagoPorEstudio = () => {
  const [pagos, setPagos] = useState([]);
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [centros, setCentros] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarFiltros = useCallback(async () => {
    setLoading(true);
    try {
      const [tRes, cRes] = await Promise.all([
        pagoPorEstudioAPI.getTiposEstudios(),
        pagoPorEstudioAPI.getCentros(),
      ]);
      setTiposEstudios(tRes.data || []);
      setCentros(cRes.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const buscar = useCallback(async (idTipoEstudio, esTecnico) => {
    setLoading(true);
    try {
      const res = await pagoPorEstudioAPI.getPagos(idTipoEstudio, esTecnico);
      setPagos(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try { await pagoPorEstudioAPI.guardar(data); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try { await pagoPorEstudioAPI.actualizar(id, data); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try { await pagoPorEstudioAPI.eliminar(id); }
    finally { setLoading(false); }
  }, []);

  return { pagos, tiposEstudios, centros, roles: ROLES, loading, cargarFiltros, buscar, guardar, actualizar, eliminar };
};
